<template>
    <div class="transaction">
        <template v-if="!isLoadingScreen && dataHistory.length > 0">
            <div class="transaction__list" v-if="!this.$store.state.isScreenPhone">
                <div class="transaction__list__header">
                    <span class="transaction__list__header-text">{{ getTranslatedText('transaction id') }}</span>
                    <span class="transaction__list__header-text">{{ getTranslatedText('ticket number') }}</span>
                    <span class="transaction__list__header-text">{{ getTranslatedText('Type') }}</span>
                    <span class="transaction__list__header-text">{{ getTranslatedText('created at') }}</span>
                    <span class="transaction__list__header-text">{{ getTranslatedText('status') }}</span>
                    <span class="transaction__list__header-text">{{ getTranslatedText('amount') }}</span>
                    <span class="transaction__list__header-text center">{{ getTranslatedText('Action') }}</span>
                </div>
                <div class="transaction__list__body">
                    <div class="transaction__list__body-item" v-for="(item, key) in dataHistory" :key="key">
                        <span class="transaction__list__body-item__item-text">{{ item.transaction_id }}</span>
                        <span class="transaction__list__body-item__item-text transaction-id">{{ item.betslip_id }}</span>
                        <span class="transaction__list__body-item__item-text type">{{ getTranslatedText(item.type) }}</span>
                        <span class="transaction__list__body-item__item-text"> {{ renderDate(item.created_at) }}</span>
                        <span class="transaction__list__body-item__item-text status"> {{ getStatus(item) }}</span>
                        <span class="transaction__list__body-item__item-text amount">{{ formatPrice(item.total_wager) }}</span>
                        <ButtonCommon
                            v-if="item.cancelable == true"
                            :type="config?.typeBtnRefresh || 'error'"
                            className="w100"
                            value="CANCEL TICKET"
                            @on-click-button-common="() => onShowConfirmCancel(item)"
                        />
                    </div>
                </div>
            </div>
            <template v-else>
                <div class="transaction__content" v-for="(item, key) in dataHistory" :key="key">
                    <div class="transaction__content-item">
                        <div class="transaction__content-item-column">
                            <span class="transaction__content-item-text title"> {{ getTranslatedText('created at') }}: </span>
                            <span class="transaction__content-item-text">
                                {{ renderDate(item.created_at) }}
                            </span>
                        </div>
                        <div class="transaction__content-item-column">
                            <span class="transaction__content-item-text title"> {{ getTranslatedText('type') }}: </span>
                            <span class="transaction__content-item-text highlight">
                                {{ getTranslatedText(item.type) }}
                            </span>
                        </div>
                    </div>
                    <div class="transaction__content-item">
                        <div class="transaction__content-item-column">
                            <span class="transaction__content-item-text title"> {{ getTranslatedText('transaction id') }}: </span>
                            <span class="transaction__content-item-text highlight">
                                {{ item.transaction_id }}
                            </span>
                        </div>
                        <div class="transaction__content-item-column">
                            <span class="transaction__content-item-text title"> {{ getTranslatedText('status') }}: </span>
                            <span :class="['transaction__content-item-text', getStatus(item)?.toLowerCase()]">
                                {{ getStatus(item) }}
                            </span>
                        </div>
                    </div>
                    <div class="transaction__content-item">
                        <div class="transaction__content-item-column">
                            <span class="transaction__content-item-text title"> {{ getTranslatedText('ticket number') }}: </span>
                            <span class="transaction__content-item-text highlight">
                                {{ item.betslip_id }}
                            </span>
                        </div>
                        <div class="transaction__content-item-column">
                            <span class="transaction__content-item-text title"> {{ getTranslatedText('amount') }}: </span>
                            <span class="transaction__content-item-text price">
                                {{ formatPrice(item.total_wager) }}
                            </span>
                        </div>
                    </div>
                    <div class="transaction__content-item" v-if="item.cancelable == true">
                        <div class="transaction__content-item-column column-button">
                            <ButtonCommon
                                :type="config?.typeBtnRefresh || 'default'"
                                className="button-cancel w100"
                                value="CANCEL TICKET"
                                @on-click-button-common="() => onShowConfirmCancel(item)"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <EmptyScreen v-if="!isLoadingScreen && dataHistory.length === 0" text="Empty result" />
        <LoadingScreen v-if="isLoadingScreen" />
        <div class="transaction__re-box-button">
            <ButtonCommon
                type="active"
                className="w100"
                value="Refresh"
                icon="refresh"
                :isLoading="isLoadingButton"
                @on-click-button-common="() => fetchHistory(item)"
            />
        </div>

        <Dialog
            :show="isOpenDialog"
            @close="closeDialog"
            @accept="accept"
            :title="dialogTitle"
            :content="dialogContent"
            :buttonLeftName="`Close`"
            :buttonRightName="`Confirm`"
            :isTranslatedContent="isTranslatedContent"
        />

        <Dialog
            title="Code Ticket"
            :show="confirmTicketCode.isShow"
            :buttonLeftName="`Close`"
            :buttonRightName="`Confirm`"
            @accept="acceptTicketCode"
            @close="closeTicketCode"
        >
            <template #dialogContent>
                <div class="transaction__code">
                    <div class="transaction__code-box">
                        <span class="transaction__code-box-label"> {{ confirmTicketCode.type }}- </span>
                    </div>
                    <div class="transaction__code-input-box">
                        <input
                            class="transaction__input-box-input"
                            v-model="confirmTicketCode.code"
                            type="text"
                            autofocus
                        />
                    </div>
                    <span v-if="confirmTicketCode.valid" class="transaction__code-valid">
                        * {{ confirmTicketCode.valid }}
                    </span>
                </div>
            </template>
        </Dialog>
    </div>
</template>
<script>
import { toRaw } from 'vue';

import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import EventBus from '@/utils/EventBus';
import HistoryService from '@/services/history/history.service.ts';
import BetslipsService from '@/services/betslip/betslip.service.ts';
import ButtonCommon from '@/components/common/button/button.vue';
import EmptyScreen from '@/components/common/emptyScreen/empty.vue';
import LoadingScreen from '@/components/common/loading/loading.vue';
import Dialog from '@/components/common/dialog/dialog.vue';
import { isStrEmpty } from '@/utils/utils';

export default {
    components: { ButtonCommon, EmptyScreen, LoadingScreen, Dialog },
    mixins: [languageMixins, utilsMixin],
    props: {
        limit: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            isLoadingButton: false,
            isLoadingScreen: false,
            dataHistory: [],
            isOpenDialog: false,
            transactionId: null,
            ticketCode: '',
            betslipId: null,
            dialogTitle: '',
            dialogContent: '',
            isTranslatedContent: true,
            config: null,
            confirmTicketCode: {
                isShow: false,
                valid: '',
                type: "L",
                code: '',
            }
        };
    },
    created() {
        const index = this.$store.state.config.features.findIndex((x) => x.name === 'history');
        if (index !== -1) this.config = this.$store.state.config.features[index];

        this.fetchHistory();
    },

    methods: {
        async fetchHistory() {
            this.isLoadingScreen = true;
            this.isLoadingButton = true;

            try {
                const resp = await HistoryService.getLastNBet(this.limit);
                if (resp.code === 200 || resp.status === 'success') {
                    this.dataHistory = resp.data;
                    this.isLoadingScreen = false;
                    this.isLoadingButton = false;
                } else {
                    this.isLoadingScreen = false;
                    this.isLoadingButton = false;
                    const param = {
                        text: resp.message,
                        type: 'error',
                    };
                    EventBus.emit('show-notications', param);
                }
            } catch (error) {
                console.log(error);
                this.isLoadingScreen = false;
                this.isLoadingButton = false;
            }
        },

        async handleCancelTicket() {
            try {
                const resp = await BetslipsService.cancelBetslip(this.betslipId);
                if (resp.code === 200 || resp.status === 'success') {
                    this.fetchHistory();
                    this.dialog = false;
                    let message = '';
                    !this.isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                              message += element.message;
                          })
                        : (message = resp.message);
                    const param = {
                        text: message ? message : this.getTranslatedText('cancel successfully'),
                        type: 'success',
                    };
                    EventBus.emit('show-notications', param);
                } else {
                    this.dialog = false;
                    let message = '';
                    !this.isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                              message += element.message;
                          })
                        : (message = resp.message);
                    const param = {
                        text: message,
                        type: 'error',
                        className: 'up-first',
                    };
                    EventBus.emit('show-notications', param);
                }
            } catch (error) {
                console.log(error);
                this.dialog = false;
            }
        },

        onShowConfirmCancel(item) {
            const itemRaw = toRaw(item);
            this.isOpenDialog = true;
            this.transactionId = itemRaw.transaction_id;
            this.betslipId = itemRaw.betslip_id;
            this.ticketCode = itemRaw.betslip_id
            this.confirmTicketCode.type = itemRaw?.betslip_id?.split('-')[0]

            this.dialogTitle = this.getTranslatedText('Are you sure you would like to cancel this Bet?');
            this.dialogContent = this.getTranslatedText('transaction identifier: [id]', {
                id: this.transactionId,
            });
        },

        // ticket code
        acceptTicketCode() {
            const {type, code} = this.confirmTicketCode
            const ticketCode = `${type}-${code}`

            if(isStrEmpty(code)) {
                this.confirmTicketCode.valid = this.getTranslatedText(`Please enter the ticket code`)
                return
            }

            if(ticketCode !== this.ticketCode) {
                this.confirmTicketCode.valid = this.getTranslatedText(`Ticket number not correct for this transaction`);
                return
            }

            this.confirmTicketCode.valid = '';
            this.handleCancelTicket();
            this.closeTicketCode();
        },

        closeTicketCode() {
            this.confirmTicketCode.isShow = false
            this.confirmTicketCode.valid = ''
            this.confirmTicketCode.type = 'L'
            this.confirmTicketCode.code = ''
        },

        getStatus(item) {
            if (item.cancelled) {
                return this.getTranslatedText('cancelled');
            } else if (parseInt(item.cancelled_count) > 0) {
                return this.getTranslatedText('cancelling');
            }
            return this.getTranslatedText('OK');
        },

        accept() {
            if(this.$store.state.isCheckTicketCode) {
                this.isOpenDialog = false;
                this.confirmTicketCode.isShow = true

                return
            }

            this.handleCancelTicket();
            this.isOpenDialog = false;
        },

        closeDialog() {
            this.isOpenDialog = false;
        },
    },
};
</script>
<style lang="scss">
@import '@/public/scss/history/historyTransaction.scss';
</style>
